export const filterData = ["onerror="];
